import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadingComponent } from './layouts/heading.component';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from './pagination/pagination.component';
import { RouterModule } from '@angular/router';
import { VehicleNavPillComponent } from './vehicle-nav-pill/vehicle-nav-pill.component';
import { ToastComponent } from './toast/toast.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SearchableDropdownComponent } from './searchable-dropdown/searchable-dropdown/searchable-dropdown.component';
import { AlertComponent } from './alert/alert.component';
import { LightboxComponent } from './lightbox/lightbox.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';




@NgModule({
  declarations: [
    HeadingComponent,
    PaginationComponent,
    VehicleNavPillComponent,
    ToastComponent,
    AlertComponent,
    LightboxComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    NgbToastModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    HeadingComponent,
    PaginationComponent,
    VehicleNavPillComponent,
    ToastComponent,
    AlertComponent,
    LightboxComponent,
  ]
})
export class SharedModule { }
